import { Drawer } from '@/new/components/drawers/drawer';
import { FactDocumentDrawerContent } from '@/new/components/reference-content/fact-document-drawer-content';

interface FactWithDocumentDrawerProps {
  factId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function FactWithDocumentDrawer({ factId, isOpen, onClose }: FactWithDocumentDrawerProps) {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} hideCloseButton={true}>
      {factId && <FactDocumentDrawerContent factId={factId} />}
    </Drawer>
  );
}
